import * as React from "react";
const SvgFiRrPlayingCards = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-playing-cards_svg__a)">
      <path
        fill="#062147"
        d="M20.466 1.967 14.78.221a5.01 5.01 0 0 0-6.224 3.24l-.188.54H5a5.006 5.006 0 0 0-5 5v10a5.006 5.006 0 0 0 5 5h6a4.98 4.98 0 0 0 3.92-1.935q.342.05.689.052a4.98 4.98 0 0 0 4.775-3.563L23.8 8.156a5.02 5.02 0 0 0-3.334-6.189M11 22H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3M21.887 7.563l-3.412 10.4a2.99 2.99 0 0 1-2.6 2.134q.123-.542.125-1.097V9a5.006 5.006 0 0 0-5-5h-.507a3 3 0 0 1 3.7-1.867l5.686 1.746a3.006 3.006 0 0 1 2.008 3.684M12 13c0 1.45-1.544 3.391-2.714 4.378a1.99 1.99 0 0 1-2.572 0C5.544 16.391 4 14.45 4 13a2 2 0 0 1 4 0 2 2 0 0 1 4 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-playing-cards_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlayingCards;
